import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { usePandaDocSyncStatus } from 'core/hooks';

import * as S from './PandaDocAnalytics.styled';

/**
 * Explains how conversion is computed and — while the rate-limited details
 * sync is still running — shows a spinner so the numbers are read as
 * provisional, not final.
 */
export const ConversionNote = memo(() => {
  const { t } = useTranslation();
  const { status } = usePandaDocSyncStatus();
  const pending = status?.detailsPending ?? 0;

  return (
    <S.InfoNote>
      <strong>{t('pages.pandadocAnalytics.conversionNote.title')}</strong>{' '}
      {t('pages.pandadocAnalytics.conversionNote.body')}
      {pending > 0 && (
        <S.UpdatingRow>
          <S.Spinner />
          {t('pages.pandadocAnalytics.conversionNote.updating', {
            count: pending,
          })}
        </S.UpdatingRow>
      )}
    </S.InfoNote>
  );
});
